export default "__VITE_ASSET__BjPpZyhJ__"